<style>
#tasks {
  height: 84px;
}
</style>

<template>
  <vue-custom-scrollbar
    class="v-bar-element"
    v-bind:settings="{suppressScrollY : true}"
    ref="bar-element"
  >
    <!-- TODO dodać uprawnienia   v-if="$can('read','tasks_registry')" -->
    <div class="group">
      <button
        @click="showRegister"
        class="ribbon-button btn--large"
      >
        <span class="icon">
          <v-icon large>list_alt</v-icon>
        </span>
        <span class="caption">REJESTR ZADAŃ</span>
      </button>
    </div>
    <div class="group">
      <button
        @click="addNewTask()"
        class="ribbon-button btn--large"
      >
        <span class="icon">
          <v-icon large>add_circle</v-icon>
        </span>
        <span class="caption">DODAJ ZADANIE</span>
      </button>
    </div>
    <div class="group">
      <button
        class="ribbon-button btn--large"
        @click="toggleTasksGeom"
        :class="{activeBtn : tasksVisibility}"
      >
        <img style="width:36px; height:36px;" :src="require('../../../assets/maptools/map_marker_icon.png')">
        <span class="caption">WIZUALIZACJA NA MAPIE</span>
      </button>
    </div>
  </vue-custom-scrollbar>
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
export default {
  components: {
    vueCustomScrollbar
  },
  data: vm => ({
    tasksVisibility: false
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
  },
  methods: {
    addNewTask() {
      this.$root.$emit("addNewTask")
    },
    showRegister() {
      this.$store.dispatch("getUsers").then(r => {
        this.show('tasksRegisterModal')
      })
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    toggleTasksGeom() {
       if (this.tasksVisibility) {
        this.tasksVisibility = false;
        this.$root.$emit("changeLayerVisibility", {layer: 'tasks', visibility: false});
        this.$emit('hideTasksFilter');
      } else {
        this.$root.$emit(
          "showSnackbar",
          "#304058",
          "Wybierz typ zadania w filtrach zadań"
        );
        this.tasksVisibility = true;
        this.$root.$emit("addGeomLayer", {layerName: 'tasks', fullName: 'Zadania', actionName: 'getTasks'});
        this.$emit('showTasksFilter');
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/tasks/Tasks.vue